<template>
    <div id="wa-business-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsapp_business_api.businessChannelDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/whatsapp-business-api')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <WhatsappBusinessIcon />
                        </div>
                        <div class="name">{{ $t("whatsapp_business_api.title") }} :{{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button type="primary" @click="visible = true" :loading="loading">
                            {{ $t("wp.startChatWithAnyNo") }}
                        </a-button>
                        <a-button type="danger" @click="deleteModal = true"
                            >{{ $t("whatsappChannel.deleteChannel") }}
                        </a-button>
                    </div>
                </div>

                <div v-if="currentTab === 'profile'">
                    <BusinessProfile v-model="channel" />
                </div>
                <div v-if="currentTab === 'detail'">
                    <UpdateDetail v-model="channel" />
                </div>
                <div v-if="currentTab === 'visibility'">
                    <Visibility v-model="channel" />
                </div>
                <div v-if="currentTab === 'templates'">
                    <TemplateMessageList v-model="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'new-template'">
                    <TemplateMessageForm :channel="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'chat-initiator-template'">
                    <ChatInitiatorTemplate v-model="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'numbers'">
                    <Numbers v-model="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'daily-usages'">
                    <DailyUsages v-model="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'broadcast-requests'">
                    <BroadcastRequests :channel="channel" :changePage="changePage" />
                </div>
                <div v-if="currentTab === 'customer-groups'">
                    <CustomerGroups
                        :channel="channel"
                        :changePage="changePage"
                        :channel-id="channel._id"
                        :isBusiness="channel.type === 'whatsapp-business-api'"
                    />
                </div>
                <div v-if="currentTab === 'all-contacts'">
                    <WhatsappContactList :channel="channel" :channel-id="channel._id" />
                </div>
                <div v-if="currentTab === 'wallet'" style="padding: 10px">
                    <Wallet />
                </div>
                <div v-if="currentTab === 'voice-configuration'">
                    <template v-if="isVoiceConfigurationEnabled()">
                        <VoiceConfiguration v-model="channel" :changePage="changePage" />
                    </template>
                    <template v-else>
                        <div class="voice-configuration-disabled">
                            <div class="disabled-content">
                                <div class="icon">
                                    <span class="material-icons">mic_off</span>
                                </div>
                                <h3>Ses Yapılandırması Devre Dışı</h3>
                                <p>Bu özellik şu anda etkin değil. Ses yapılandırması özelliğini kullanmak için planınızı yükseltmeniz gerekebilir.</p>
                                <SupsisButton primary @click="upgradePlan">Planı Yükselt</SupsisButton>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="currentTab === 'comparison'" style="padding: 20px">
                    <WhatsappComparison />
                </div>
                <div v-if="currentTab === 'developer'">
                    <DeveloperSettings v-model="channel" />
                </div>
            </div>
        </div>
        <WhatsappStartChat
            v-if="channel"
            :visibleStartChat="visible"
            :show-alert-message="showAlertMessage"
            :channel-id="channel._id"
            :channel="channel"
            @modal-closed="visible = false"
        />
        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import WhatsappWizard from "../../WhatsappV1/update/WhatsappWizard.vue";
import ContactListV2 from "../../WhatsappV1/ContactListV2.vue";
import SettingsMultiWhatsapp from "../../WhatsappV1/SettingsMultiWhatsapp.vue";
import WhatsappBusinessIcon from "../../Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import IconButton from "../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../utils/log2";
import WABusinessMenuTypes from "./WABusinessMenuTypes";
import TemplateMessageList from "./TemplateMessageList.vue";
import TemplateMessageForm from "./template/TemplateMessageForm.vue";
import BroadcastRequests from "./broadcast/BroadcastRequests.vue";
import CustomerGroups from "./broadcast/CustomerGroups.vue";
import WhatsappContactList from "../../IntegrationChannelsItem/WhatsappContactList.vue";
import UpdateDetail from "./UpdateDetail.vue";
import ChatInitiatorTemplate from "./ChatInitiatorTemplate.vue";
import Numbers from "./Numbers.vue";
import VueCountryCode from "vue-country-code";
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { filter, first, timeout } from "rxjs/operators";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import DailyUsages from "./DailyUsages.vue";
import Wallet from "../../Settings/pages/general/Wallet.vue";
import WhatsappStartChat from "../../IntegrationChannelsItem/WhatsappStartChat.vue";
import { getOrUpdateFilters } from "../../../../utils/persistenceStorage";
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import ChatWatcher from "../../../../ChatWatcherV2";
import BusinessProfile from "./BusinessProfile";
import VoiceConfiguration from "./VoiceConfiguration.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import WhatsappComparison from "../../../../components/WhatsappComparison.vue";
import DeveloperSettings from "../../Integrations/components/DeveloperSettings.vue";

const filters = getOrUpdateFilters("whatsapp-business-api");
const log = log2("WhatsappBusinessChannelDetail.vue");
export default Vue.extend({
    name: "WhatsappBusinessChannelDetail",
    components: {
        DailyUsages,
        VueCountryCode,
        Numbers,
        ChatInitiatorTemplate,
        UpdateDetail,
        CustomerGroups,
        BroadcastRequests,
        TemplateMessageForm,
        TemplateMessageList,
        Visibility,
        ChannelMenu,
        IconButton,
        WhatsappBusinessIcon,
        SettingsMultiWhatsapp,
        ContactListV2,
        WhatsappWizard,
        WhatsappContactList,
        AppBreadCrumb,
        Wallet,
        WhatsappStartChat,
        SidebarChild,
        BusinessProfile,
        VoiceConfiguration,
        SupsisButton,
        WhatsappComparison,
        DeveloperSettings,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(WABusinessMenuTypes.Items(this)).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
            menuItems: WABusinessMenuTypes.Items(this),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-business-api"),
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        isVoiceConfigurationEnabled() {
            return this.$feature.isVoiceConfigurationEnabled();
        },
        init() {
            console.log("init");
            if (this.channel) {
                sendSocketMessage("whatsapp refresh-template", {
                    channelId: this.channel._id,
                    siteId: this.channel.siteId,
                });
            }
            this.channel = this.channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
            this.channel = _.cloneDeep(this.channel);
        },
        changePage(page) {
            this.currentTab = page;
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.form.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        deleteWhatsappChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/whatsapp-business-api");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
        startChat(whatsappNumber) {
            log("startChat", { whatsappNumber });
            whatsappNumber = whatsappNumber || "";
            whatsappNumber = this.dialCode + whatsappNumber;
            ChatWatcher.startChatImmediately({
                whatsappNumber,
                channelId: this.channel._id,
                channelType: "whatsapp-business-api",
            });
        },
        upgradePlan() {
            this.$router.push("/billing/plans/whatsapp-voice-call");
        },
    },
    async mounted() {
        this.init();
    },
    watch: {
        channels: {
            handler() {
                this.init();
            },
            deep: true,
        },
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(this.menuItems).find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/whatsapp-business-api/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#wa-business-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                background: #58ca64;
                padding: 10px;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }

    .voice-configuration-disabled {
        padding: 40px 20px;
        text-align: center;

        .disabled-content {
            max-width: 400px;
            margin: 0 auto;

            .icon {
                margin-bottom: 20px;

                .material-icons {
                    font-size: 48px;
                    color: var(--color-text-secondary, #8c8c8c);
                }
            }

            h3 {
                margin-bottom: 12px;
                color: var(--color-text-primary, #333);
                font-size: 18px;
                font-weight: 600;
            }

            p {
                color: var(--color-text-secondary, #666);
                line-height: 1.5;
                margin: 0 0 20px 0;
            }

            .supsis-button {
                margin: 8px auto 0 auto;
                display: block;
            }
        }
    }
}
</style>
